import { PrismicRichText, PrismicRichTextProps } from '@prismicio/react'
import Link from 'next/link'
import styled from 'styled-components'

import { RightArrow } from '../../../public/icons/Icons'
import { AudurLink } from '../../prismic/prismicTypes'

// Container components
const CTASectionContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 40px;
	margin-top: 40px;

	@media (max-width: 599px) {
		flex-direction: column;
		gap: 12px;
		margin-top: 24px;
		padding: 24px;
	}
`

const CTAMessageWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

// Text components
const CTAHeading = styled.h4`
	font-weight: bold;
	font-size: 34px;
	line-height: 44px;
	margin: 0;

	@media (max-width: 979px) {
		font-size: 24px;
		line-height: 32px;
	}
`

const CTAContent = styled.div`
	color: white;
	margin: 0;

	font-size: 18px;
	line-height: 24px;

	@media (max-width: 979px) {
		font-size: 16px;
		line-height: 22px;
	}
`

const StyledButtonLink = styled(Link)`
	display: flex;
	align-items: center;
	justify-content: center;
	align-self: center;
	background-color: transparent;
	border: 2px solid #f5f5f5;
	border-radius: 28px;
	min-width: 118px;
	height: 24px;
	padding: 16px;
	box-sizing: content-box;
	text-decoration: none;
	font-weight: 400;
	transition: all 0.2s ease;

	@media (max-width: 599px) {
		align-self: flex-start;
	}

	&:hover {
		background-color: rgba(245, 245, 245, 0.1);
	}

	&:active {
		color: #dbdbdb;
		background-color: rgba(245, 245, 245, 0.1);
	}

	&:disabled {
		border-color: #757982;
	}
`

const ButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	font-size: 16px;
	line-height: 20px;
`

interface CTASectionProps {
	title: string | undefined
	description: PrismicRichTextProps['field']
	linkText?: string
	link?: AudurLink
}

const CTASection = ({ title, description, linkText, link }: CTASectionProps) => {
	return (
		<CTASectionContainer>
			<CTAMessageWrapper>
				<CTAHeading>{title}</CTAHeading>
				<CTAContent>
					<PrismicRichText field={description} />
				</CTAContent>
			</CTAMessageWrapper>
			{link && linkText && (
				<StyledButtonLink href={link.linkUrl || '/'}>
					<ButtonContent>
						{linkText}
						<RightArrow width={24} height={24} />
					</ButtonContent>
				</StyledButtonLink>
			)}
		</CTASectionContainer>
	)
}

export default CTASection
